import { ORDER_STATUS, SERVICE_TYPES } from '@bagonboard/wiseman';

import { fetchGet, fetchPut }   from '../../providers/Fetch';
import { getQueryStringFilter } from '../../modules/getUrls';

import {
  SERVICES_ERROR,
  SERVICES_REQUEST,
  SERVICES_SUCCESS,
  SERVICES_STATUS_UPDATE,
  SERVICES_SET_FILTERS,
} from './types';

const { OPEN, AWAITING } = ORDER_STATUS;

export const servicesError = error => ({
  type: SERVICES_ERROR,
  error,
});

export const servicesRequest = {
  type: SERVICES_REQUEST,
};

export const servicesSuccess = data => ({
  type: SERVICES_SUCCESS,
  data,
});

export const servicesStatusUpdate = service => ({
  type: SERVICES_STATUS_UPDATE,
  data: service,
});

export const servicesSetFilters = filters => ({
  type: SERVICES_SET_FILTERS,
  filters,
});

export const servicesFetch = ({
  filtered = [],
  from,
  page = 0,
  pageSize = 10,
  sorted = [],
  to,
}) => async (dispatch) => {
  const type = [SERVICE_TYPES.SKIP_BAGGAGE_CLAIM, SERVICE_TYPES.CHECKIN];
  dispatch(servicesRequest);
  dispatch(
    servicesSetFilters({
      filtered,
      from,
      page,
      pageSize,
      sorted,
      to,
      type,
    }),
  );
  try {
    const queryString = getQueryStringFilter({
      filtered,
      from,
      page,
      pageSize,
      sorted,
      to,
      type,
    });

    const url = `/services?${queryString}`;
    const result = await fetchGet(url);

    dispatch(servicesSuccess(result));
  } catch (e) {
    dispatch(servicesError(e.message));
  }
};

export const assignAgentToService = ({ serviceId, agentId }) => async (dispatch, getState) => {
  dispatch(servicesRequest);
  try {
    const {
      services: {
        data: { services },
      },
    } = getState();
    // eslint-disable-next-line no-underscore-dangle
    const service = services.find(s => s._id === serviceId);
    if ([OPEN, AWAITING].includes(service.order.status)) {
      dispatch(servicesError("Can't assign a driver to an unconfirmed order"));
    } else {
      const result = await fetchPut('order/service/agent', { serviceId, agentId });
      dispatch(servicesStatusUpdate(result));
    }
  } catch (e) {
    dispatch(servicesError(e.message));
  }
};
